const REQUIREMENTS = [
	{ test: (pw) => pw.length >= 10, label: 'At least 10 characters' },
	{ test: (pw) => /[a-z]/.test(pw) && /[A-Z]/.test(pw), label: 'At least 1 uppercase and 1 lowercase letter' },
	{ test: (pw) => /[0-9]/.test(pw), label: 'At least 1 digit' },
	{ test: (pw) => /[^a-zA-Z0-9]/.test(pw), label: 'At least 1 special character' },
];

function PasswordRequirements({ password = '' }) {
	return (
		<ul style={{ listStyle: 'none', padding: 0, margin: '4px 0 0 0', fontSize: '13px' }}>
			{REQUIREMENTS.map(({ test, label }) => {
				const met = password.length > 0 && test(password);
				return (
					<li key={label} style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '2px', color: password.length === 0 ? '#666' : met ? '#22c55e' : '#ef4444' }}>
						<span style={{ fontSize: '14px' }}>{password.length === 0 ? '○' : met ? '✓' : '✗'}</span>
						{label}
					</li>
				);
			})}
		</ul>
	);
}

export default PasswordRequirements;
